/**
 * Why a turn stopped, said to the user (design D53): what happened in a sentence, and that
 * nothing was lost. The raw error stays behind Details.
 */
export function explainTurnFailure(message: string): string {
  const text = message.toLowerCase();
  if (/overload|\b529\b|capacity|unavailable|\b503\b/.test(text))
    return 'The model was overloaded. Nothing was lost; the agent can pick up where it stopped.';
  if (/rate.?limit|\b429\b|too many requests|quota/.test(text))
    return 'The model’s limit was reached. Nothing was lost; try again in a moment.';
  if (/network|fetch failed|econn|socket|timed? ?out|disconnect|offline/.test(text))
    return 'The connection to the agent dropped. Nothing was lost; the agent can pick up where it stopped.';
  return 'Something went wrong. Nothing was lost; the agent can pick up where it stopped.';
}

/** What Try again sends: the agent continues where it stopped. */
export const TRY_AGAIN_MESSAGE = 'Continue where you stopped.';
